import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';
import { ASIDE_PANEL_COLUMN_RELEASE } from '../../../../types/rest/IUserMeta';
import { getUserAllowCommentsColumnView } from './getUserAllowCommentsColumnView';

export const getUserCommentsColumnView = (
    state: IApplicationState,
): boolean => {
   if (!getUserAllowCommentsColumnView(state)) return false;
    const user = getAuthUser(state);
    let isCommentsColumnView = user && user.meta && user.meta.isCommentsColumnView;
    if (isCommentsColumnView === undefined && user.createDateTimeStamp > ASIDE_PANEL_COLUMN_RELEASE) {
        return true;
    }
    return isCommentsColumnView;
};
